<template>
	<component
	:is="tag"
	v-bind="$attrs"
	role="button" class="
	
	hover:outline 
	outline-gray-300
	active:outline-red-600 
	active:bg-red-600
	outline-2
	p-1
	pr-2 
	rounded"
	:class="styleOverride?'':style">
		<div class="
	flex flex-none flex-col 
	justify-center
	
	items-center" >
			<div class="inline-flex
			items-center
			gap-1 w-fit">
			<img v-if="estructura" class='flex-none object-contain h-4 w-4 md:h-6 md:w-6 ' :class="styleOverride?'brightness-0':c.color.brightness" :src="require('@/assets/estructures/ico/ico'+c.img)"/>
			
			<p>{{ c.etiqueta }}</p>
			<div v-if="c.resultat!=='d'" class="p-1 aspect-square h-5 font-bold rounded flex items-center justify-center mr-1" :class="c.color.format_resultat">{{ c.resultat }}</div>
			<img v-if="novetat" class="h-4 w-4 drop-shadow" :src="Novetat"/>
		</div>
			<!--<p v-if="estrelles" class="text-sm text-center h-4 flex items-center">{{ c.estrelles }}</p>-->
			<p v-if="estrelles"><EstrellesFA class="text-[0.65rem] text-center h-4 flex items-center" :gamma="c.gamma"/>
      </p>
			<div v-if="punts" class="flex w-full h-4 text-white font-bold text-xs justify-around text-nowrap gap-1 mt-1">
				<p class="bg-resultat-descarregat rounded flex items-center px-1">d: {{c.punts.descarregat}}</p>
				<p class="bg-resultat-carregat rounded flex items-center px-1">c: {{c.punts.carregat}}</p>
			</div><div v-if="puntuat" class="flex w-full h-4 text-white font-bold text-xs justify-around text-nowrap mt-1">
				<p  v-if="c.resultat=='d'" class="bg-resultat-descarregat rounded flex items-center px-1">{{c.puntuat}}</p>
				<p  v-if="c.resultat=='c'" class="bg-resultat-carregat rounded flex items-center px-1"> {{c.puntuat}}</p>
				<p  v-if="c.resultat=='i'" class="bg-resultat-intent rounded flex items-center px-1"> {{c.puntuat}}</p>
				<p  v-if="c.resultat=='id'" class="bg-resultat-desmuntat rounded flex items-center px-1"> {{c.puntuat}}</p>
			</div>
		</div>
    </component>
</template>
<script setup>
import {defineProps} from 'vue';
import castell from '@/functions/notacioCastell.js';
import EstrellesFA from './EstrellesFA.vue';
import Novetat from '@/assets/novetat.svg'

const props=defineProps({
	tag:{
		type:String,
		default:'div'
	},
    castell:{
        type:String,
        default:"pd4"
    },
    universitaria:{
        type:Boolean,
        required:false,
        default:false
    },
	estrelles:{
        type:Boolean,
        required:false,
        default:false
	},
	punts:{
        type:Boolean,
        required:false,
        default:false
	},
	estructura:{
        type:Boolean,
        required:false,
        default:true
	},
	compacte:{
        type:Boolean,
        required:false,
        default:false
	},
	puntuat:{
        type:Boolean,
        required:false,
        default:false
	},
	novetat:{
        type:Boolean,
        required:false,
        default:false
	},
	styleOverride:{
        type:Boolean,
        required:false,
        default:false
	}
});


const c = castell(props.castell,props.universitaria);
const style= ' bg-'+c.color.gamma+' text-'+c.color.text;
</script>